const VENDOR_CONFIG_FIELDS = `{
  pluType,
  constantPlu,
  parentChildPlu {
    plu,
    childPlu
  },
  sizeBasedPlu {
    comboPlu,
    comboSize
  }
}`;

export const VENDOR_CONFIGS = `vendorConfigs {
  carrols ${VENDOR_CONFIG_FIELDS},
  carrolsDelivery ${VENDOR_CONFIG_FIELDS},
  ncr ${VENDOR_CONFIG_FIELDS},
  ncrDelivery ${VENDOR_CONFIG_FIELDS},
  qdi ${VENDOR_CONFIG_FIELDS},
  qdiDelivery ${VENDOR_CONFIG_FIELDS},
}`;

const POS_IDS_CONFIGURATION = `posIdsConfiguration {
  plu ${VENDOR_CONFIG_FIELDS}
}`;

// Reusable projection for systemwideOffer documents (used at top-level and
// nested inside systemwideTierGroup/offerGroup offers arrays)
const SYSTEMWIDE_OFFER_PROJECTION = `{
  _id,
  _type,
  loyaltyEngineId,
  partnerOfferType,
  "name": { "localeRaw": name[$language] },
  "description": { "localeRaw": description[$language] },
  "moreInfo": { "localeRaw": moreInfo[$language] },
  backgroundImage { asset-> { _id } },
  shortCode,
  mobileOrderOnly,
  daypart,
  redemptionType,
  offerPrice,
  "marketPrice": marketPrice[defined(@)]->{
    _id,
    _type,
    ${VENDOR_CONFIGS}
  },
  "localizedImage": { "locale": localizedImage[$language] {
    app { asset-> { _id } },
    imageDescription
  } },
  uiPattern,
  ${POS_IDS_CONFIGURATION},
  "incentives": incentives[defined(@)]->{
    _id,
    _type,
    ${VENDOR_CONFIGS},
    isOfferBenefit,
    discountValue,
    discountType,
    "operationalItem": operationalItem { daypart },
    "mainItem": mainItem->{
      _id,
      _type,
      "operationalItem": operationalItem { daypart },
      ${VENDOR_CONFIGS}
    },
    "options": options[defined(@)]->{
      minAmount,
      "options": options[]{
        maxAmount,
        enableUpsellPricing,
        showOnlyForTreatmentGroup,
        "option": option->{
          ${VENDOR_CONFIGS},
          isOfferBenefit,
          "mainItem": mainItem->{
            _id,
            _type,
            "operationalItem": operationalItem { daypart },
            ${VENDOR_CONFIGS}
          },
        }
      },
      ${VENDOR_CONFIGS}
    },
    "pickerAspects": pickerAspects[defined(@)]-> { _id }
  },
  ${VENDOR_CONFIGS}
}`;

const OFFER_GROUP_PROJECTION = `{
  _id,
  _type,
  loyaltyEngineId,
  canOnlyChooseOne,
  "name": { "localeRaw": name[$language] },
  "description": { "localeRaw": description[$language] },
  "localizedImage": { "locale": localizedImage[$language] {
    app { asset-> { _id } },
    imageDescription
  } },
  "offers": offers[defined(@)]-> ${SYSTEMWIDE_OFFER_PROJECTION}
}`;

const SORTED_SYSTEMWIDE_OFFERS_PROJECTION = `sortedSystemwideOffers[defined(@)]->{
  _id,
  _type,
  _type == "systemwideOffer" => ${SYSTEMWIDE_OFFER_PROJECTION},
  _type == "systemwideTierGroup" => {
    "tierGroupName": name,
    discount_rate,
    min_discount_rate,
    max_discount_rate,
    "menu_items": menu_items[defined(@)]->{
      _id,
      _type,
      ${VENDOR_CONFIGS}
    },
    "offers": offers[defined(@)]-> ${SYSTEMWIDE_OFFER_PROJECTION},
    "legacyOffers": legacyOffers[defined(@)]-> { _id }
  },
  _type == "offerGroup" => ${OFFER_GROUP_PROJECTION}
}`;

export const LOYALTY_OFFER_GROUPS_BY_IDS_GROQ = `
  *[_type == "offerGroup" && _id in $ids] ${OFFER_GROUP_PROJECTION}
`;

export const SORTED_LOYALTY_OFFERS_GROQ = `
  *[_id == "feature-loyalty-offers-ui-singleton"][0] {
    _id,
    "sortedSystemwideOffers": ${SORTED_SYSTEMWIDE_OFFERS_PROJECTION},
    "autoEnabledSystemwideOffers": autoEnabledSystemwideOffers[defined(@)]-> ${SYSTEMWIDE_OFFER_PROJECTION}
  }
`;
